import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";

const PublicNavigation = () => {
    return(
        <div id={'navigation'} className={''}>
            <Container className={'pt-2 pb-2'}>
                <Row>
                    <Col md={2} className={'d-flex justify-content-left align-items-center'}>
                        <div className={''}>
                            <a href={'/'}>
                                <Image src="/img/podsy-logo.jpg" fluid />
                            </a>
                        </div>
                    </Col>
                    <Col md={10}>
                        <div className={''}>
                            <Navbar expand="lg" className="">
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Nav className="ms-auto align-items-center">
                                        <Nav.Link href="/">Home</Nav.Link>
                                        <Nav.Link href="/pricing">Pricing</Nav.Link>

                                        <Button as="a" href="/login" variant="primary">
                                            Login
                                        </Button>
                                        &nbsp;
                                        &nbsp;
                                        <Button as="a" href="/signup" variant="primary">
                                            Sign Up
                                        </Button>

                                    </Nav>
                                </Navbar.Collapse>
                            </Navbar>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default PublicNavigation;